(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AnimalSectionCVolunteerPhotos"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
var carousel = $(".customizable-blocks");
carousel.slick({
infinite: false,
slidesToShow: 3,
slidesToScroll: 1,
prevArrow: '<button type="button" class="slick-prev" style="color: #77a0b1;">❮</button>',
nextArrow: '<button type="button" class="slick-next" style="color: #77a0b1;">❯</button>'
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AnimalSectionVolunteerPhotos"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
var carousel = $(".customizable-blocks");
carousel.slick({
arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" style="color: #77a0b1;">❮</button>',
    nextArrow: '<button type="button" class="slick-next" style="color: #77a0b1;">❯</button>',
  responsive: [
        {
          breakpoint: 768, // This is the mobile breakpoint
          settings: {
            arrows: true, // Show arrows on mobile
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
    ]
});

  // Get the modal and the close button
  var modal = document.getElementById("myModal");
  var closeButton = document.getElementsByClassName("close")[0];

  // Create the modal content
var createModalContent = function() {
  var currentExpanded = $("#shopify-section-Donkies .customizable-blocks").clone();
  currentExpanded.find('.slick-prev, .slick-next').remove(); // Remove the carousel controls
  currentExpanded.find('.customizable-block').css({
    'display': 'inline-block',
    'width': '25%',
    'margin': '0 5px 10px' // Add the margin to the block
  }); // Display blocks inline
  currentExpanded.removeClass('slick-initialized slick-slider').removeAttr('dir').css({
    'display': 'flex',
    'flex-wrap': 'wrap', // Wrap the blocks
    'justify-content': 'center', // Center the blocks
    'max-height': 'calc(100vh - 4%)', // Set max-height to 100vh - 4% to account for the vertical margins
    'overflow': 'auto' // Enable scrolling when content exceeds the maximum height
  }); // Remove slick-related attributes and display as flex
currentExpanded.find('.slick-slide').css({
    'width': 'auto',
    'position': 'static'
  }); // Set the width of the slick-slide to auto and position to static
  currentExpanded.find('.slick-list').css('width', '100%'); // Set the width of the slick-list to 100%
  currentExpanded.find('.slick-track').css('width', 'auto'); // Set the width of the slick-track to auto
  return currentExpanded.html();
};

  // Open the modal and display the content
  $(".expand-button").on("click", function() {
    modal.style.display = "block";
    document.body.style.overflow = "hidden";
    $(".modal-content .content").html( $(this).closest('.customizable-blocks-wrapper').find('.customizable-blocks1').html());
  });

  // Close the modal when the close button is clicked
  closeButton.onclick = function() {
    modal.style.display = "none";
    document.body.style.overflow = "unset";
  };

  // Close the modal when the user clicks outside the modal content
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      document.body.style.overflow = "unset";
    }
  };

  // Change the background color of empty headers and text boxes
  $(".customizable-block h2, .customizable-block p").each(function() {
    if ($(this).text().trim() === "") {
      $(this).css("background-color", "#dceceb");
    }
  });

  $(".customizable-block h2").each(function() {
    var headerText = $(this).text();
    var blockUrl = $(this).parent().find("a").attr("href");
    $(this).html('<a href="' + blockUrl + '" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: none;">' + headerText + '</a>');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Arlo"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-BenjaminBunny"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Brooks"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Buckeye"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Cola"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Compadre"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Danny"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Dolly"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Dorcus"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Elvis"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Fanta"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Finn"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Granny"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Gus"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Harvey"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Moo"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Orion"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Patrick"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Pepper"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Riggs"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Salt"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Shadow"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Shasta"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Teddy"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-Willie"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkey-YosemitieSam"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Donkies"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var carousel = $(".customizable-blocks");
  carousel.slick({
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" style="color: #77a0b1;">❮</button>',
    nextArrow: '<button type="button" class="slick-next" style="color: #77a0b1;">❯</button>',
    responsive: [
        {
          breakpoint: 768, // This is the mobile breakpoint
          settings: {
            arrows: true, // Show arrows on mobile
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
    ]
  });

  // Get the modal and the close button
  var modal = document.getElementById("myModal");
  var closeButton = document.getElementsByClassName("close")[0];

  // Create the modal content
var createModalContent = function() {
  var currentExpanded = $("#shopify-section-Donkies .customizable-blocks").clone();
  currentExpanded.find('.slick-prev, .slick-next').remove(); // Remove the carousel controls
  currentExpanded.find('.customizable-block').css({
    'display': 'inline-block',
    'width': '25%',
    'margin': '0 5px 10px' // Add the margin to the block
  }); // Display blocks inline
  currentExpanded.removeClass('slick-initialized slick-slider').removeAttr('dir').css({
    'display': 'flex',
    'flex-wrap': 'wrap', // Wrap the blocks
    'justify-content': 'center', // Center the blocks
    'max-height': 'calc(100vh - 4%)', // Set max-height to 100vh - 4% to account for the vertical margins
    'overflow': 'auto' // Enable scrolling when content exceeds the maximum height
  }); // Remove slick-related attributes and display as flex
  currentExpanded.find('.slick-slide').css({
    'width': 'auto',
    'position': 'static'
  }); // Set the width of the slick-slide to auto and position to static
  currentExpanded.find('.slick-list').css('width', '100%'); // Set the width of the slick-list to 100%
  currentExpanded.find('.slick-track').css('width', 'auto'); // Set the width of the slick-track to auto
  return currentExpanded.html();
};

  // Open the modal and display the content
  $(".expand-button").on("click", function() {
    modal.style.display = "block";
    document.body.style.overflow = "hidden";
    $(".modal-content .content").html( $(this).closest('.customizable-blocks-wrapper').find('.customizable-blocks1').html());
  });

  // Close the modal when the close button is clicked
  closeButton.onclick = function() {
    modal.style.display = "none";
    document.body.style.overflow = "unset";
  };

  // Close the modal when the user clicks outside the modal content
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      document.body.style.overflow = "unset";
    }
  };

  // Change the background color of empty headers and text boxes
  $(".customizable-block h2, .customizable-block p").each(function() {
    if ($(this).text().trim() === "") {
      $(this).css("background-color", "#dceceb");
    }
  });

  $(".customizable-block h2").each(function() {
    var headerText = $(this).text();
    var blockUrl = $(this).parent().find("a").attr("href");
    $(this).html('<a href="' + blockUrl + '" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: none;">' + headerText + '</a>');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Benjamin"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Bob"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Butters"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Dorcus"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Elliot"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Karl"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Lilo2"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Lolly"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Moo"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Oliver"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Otis"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Peter"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Pickles"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Pops"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Roo"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Stitch"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goat-Thumbellina"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Goats"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var carousel = $(".customizable-blocks");
  carousel.slick({
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" style="color: #77a0b1;">❮</button>',
    nextArrow: '<button type="button" class="slick-next" style="color: #77a0b1;">❯</button>'
  });

  // Get the modal and the close button
  var modal = document.getElementById("myModal");
  var closeButton = document.getElementsByClassName("close")[0];

  // Create the modal content
var createModalContent = function() {
  var currentExpanded = $("#shopify-section-Donkies .customizable-blocks").clone();
  currentExpanded.find('.slick-prev, .slick-next').remove(); // Remove the carousel controls
  currentExpanded.find('.customizable-block').css({
    'display': 'inline-block',
    'width': '25%',
    'margin': '0 5px 10px' // Add the margin to the block
  }); // Display blocks inline
  currentExpanded.removeClass('slick-initialized slick-slider').removeAttr('dir').css({
    'display': 'flex',
    'flex-wrap': 'wrap', // Wrap the blocks
    'justify-content': 'center', // Center the blocks
    'max-height': 'calc(100vh - 4%)', // Set max-height to 100vh - 4% to account for the vertical margins
    'overflow': 'auto' // Enable scrolling when content exceeds the maximum height
  }); // Remove slick-related attributes and display as flex
  currentExpanded.find('.slick-slide').css({
    'width': 'auto',
    'position': 'static'
  }); // Set the width of the slick-slide to auto and position to static
  currentExpanded.find('.slick-list').css('width', '100%'); // Set the width of the slick-list to 100%
  currentExpanded.find('.slick-track').css('width', 'auto'); // Set the width of the slick-track to auto
  return currentExpanded.html();
};

  // Open the modal and display the content
  $(".expand-button").on("click", function() {
    modal.style.display = "block";
    $(".modal-content .content").html( $(this).closest('.customizable-blocks-wrapper').find('.customizable-blocks1').html());
  });

  // Close the modal when the close button is clicked
  closeButton.onclick = function() {
    modal.style.display = "none";
  };

  // Close the modal when the user clicks outside the modal content
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  // Change the background color of empty headers and text boxes
  $(".customizable-block h2, .customizable-block p").each(function() {
    if ($(this).text().trim() === "") {
      $(this).css("background-color", "#dceceb");
    }
  });

  $(".customizable-block h2").each(function() {
    var headerText = $(this).text();
    var blockUrl = $(this).parent().find("a").attr("href");
    $(this).html('<a href="' + blockUrl + '" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: none;">' + headerText + '</a>');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Alvin"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Autumn"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Benny"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Bo"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Cash"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Clementine"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Daisy"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Doc"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Elsa"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Foster"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-George"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Hercules"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Huck"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Izzy"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-June"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Lucy"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Mae"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Maggie"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Max"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Meg"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Pegasus"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Piper"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Rosie"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Sabrina"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Scout"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Simon"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Spirt"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Stella"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Stryker"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Summer"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Theodore"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Willow"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horse-Wonder"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Horses"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var carousel = $(".customizable-blocks");
  carousel.slick({
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" style="color: #77a0b1;">❮</button>',
    nextArrow: '<button type="button" class="slick-next" style="color: #77a0b1;">❯</button>'
  });

  // Get the modal and the close button
  var modal = document.getElementById("myModal");
  var closeButton = document.getElementsByClassName("close")[0];

  // Create the modal content
var createModalContent = function() {
  var currentExpanded = $("#shopify-section-Donkies .customizable-blocks").clone();
  currentExpanded.find('.slick-prev, .slick-next').remove(); // Remove the carousel controls
  currentExpanded.find('.customizable-block').css({
    'display': 'inline-block',
    'width': '25%',
    'margin': '0 5px 10px' // Add the margin to the block
  }); // Display blocks inline
  currentExpanded.removeClass('slick-initialized slick-slider').removeAttr('dir').css({
    'display': 'flex',
    'flex-wrap': 'wrap', // Wrap the blocks
    'justify-content': 'center', // Center the blocks
    'max-height': 'calc(100vh - 4%)', // Set max-height to 100vh - 4% to account for the vertical margins
    'overflow': 'auto' // Enable scrolling when content exceeds the maximum height
  }); // Remove slick-related attributes and display as flex
  currentExpanded.find('.slick-slide').css({
    'width': 'auto',
    'position': 'static'
  }); // Set the width of the slick-slide to auto and position to static
  currentExpanded.find('.slick-list').css('width', '100%'); // Set the width of the slick-list to 100%
  currentExpanded.find('.slick-track').css('width', 'auto'); // Set the width of the slick-track to auto
  return currentExpanded.html();
};

  // Open the modal and display the content
  $(".expand-button").on("click", function() {
    modal.style.display = "block";
    $(".modal-content .content").html( $(this).closest('.customizable-blocks-wrapper').find('.customizable-blocks1').html());
  });

  // Close the modal when the close button is clicked
  closeButton.onclick = function() {
    modal.style.display = "none";
  };

  // Close the modal when the user clicks outside the modal content
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  // Change the background color of empty headers and text boxes
  $(".customizable-block h2, .customizable-block p").each(function() {
    if ($(this).text().trim() === "") {
      $(this).css("background-color", "#dceceb");
    }
  });

  $(".customizable-block h2").each(function() {
    var headerText = $(this).text();
    var blockUrl = $(this).parent().find("a").attr("href");
    $(this).html('<a href="' + blockUrl + '" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: none;">' + headerText + '</a>');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Mule-BigJohn"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Remembering"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var carousel = $(".customizable-blocks");
  carousel.slick({
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" style="color: #77a0b1;">❮</button>',
    nextArrow: '<button type="button" class="slick-next" style="color: #77a0b1;">❯</button>'
  });

  // Get the modal and the close button
  var modal = document.getElementById("myModal");
  var closeButton = document.getElementsByClassName("close")[0];

  // Create the modal content
var createModalContent = function() {
  var currentExpanded = $("#shopify-section-Donkies .customizable-blocks").clone();
  currentExpanded.find('.slick-prev, .slick-next').remove(); // Remove the carousel controls
  currentExpanded.find('.customizable-block').css({
    'display': 'inline-block',
    'width': '25%',
    'margin': '0 5px 10px' // Add the margin to the block
  }); // Display blocks inline
  currentExpanded.removeClass('slick-initialized slick-slider').removeAttr('dir').css({
    'display': 'flex',
    'flex-wrap': 'wrap', // Wrap the blocks
    'justify-content': 'center', // Center the blocks
    'max-height': 'calc(100vh - 4%)', // Set max-height to 100vh - 4% to account for the vertical margins
    'overflow': 'auto' // Enable scrolling when content exceeds the maximum height
  }); // Remove slick-related attributes and display as flex
  currentExpanded.find('.slick-slide').css({
    'width': 'auto',
    'position': 'static'
  }); // Set the width of the slick-slide to auto and position to static
  currentExpanded.find('.slick-list').css('width', '100%'); // Set the width of the slick-list to 100%
  currentExpanded.find('.slick-track').css('width', 'auto'); // Set the width of the slick-track to auto
  return currentExpanded.html();
};

  // Open the modal and display the content
  $(".expand-button").on("click", function() {
    modal.style.display = "block";
    $(".modal-content .content").html( $(this).closest('.customizable-blocks-wrapper').find('.customizable-blocks1').html());
  });

  // Close the modal when the close button is clicked
  closeButton.onclick = function() {
    modal.style.display = "none";
  };

  // Close the modal when the user clicks outside the modal content
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  // Change the background color of empty headers and text boxes
  $(".customizable-block h2, .customizable-block p").each(function() {
    if ($(this).text().trim() === "") {
      $(this).css("background-color", "#dceceb");
    }
  });

  $(".customizable-block h2").each(function() {
    var headerText = $(this).text();
    var blockUrl = $(this).parent().find("a").attr("href");
    $(this).html('<a href="' + blockUrl + '" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: none;">' + headerText + '</a>');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Blossom"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Chamomile"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Flower"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Hazel"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Honey"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Honeydew"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Nancy"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Pearl"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Ruby"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep-Stargazer"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  setupThumbnailClicks();
  carouselNavigation();
  carouselNavigation2();
});

function setupThumbnailClicks() {
  var thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
  var mainImage = document.querySelector(".image-gallery-main");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      mainImage.src = thumbnail.dataset.src;
    });
  });
}

function carouselNavigation() {
  const carousel = document.querySelector('.carousel');
  const leftArrow = document.querySelector('.carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}

function carouselNavigation2() {
  const carousel = document.querySelector('.carousel-container2 .carousel');
  const leftArrow = document.querySelector('.carousel-container2 .carousel-arrow--left');
  const rightArrow = document.querySelector('.carousel-container2 .carousel-arrow--right');
  let currentIndex = 0;

  function slideCarousel(direction) {
    const carouselItems = document.querySelectorAll('.carousel-container2 .carousel-item');
    const numberOfItems = carouselItems.length;
    const containerWidth = carousel.clientWidth;

    if (direction === 'right') {
      currentIndex++;
      if (currentIndex >= numberOfItems - 1) {
        currentIndex = numberOfItems - 1;
      }
    } else if (direction === 'left') {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    const transformValue = `translateX(-${currentIndex * containerWidth}px)`;
    carousel.style.transform = transformValue;
  }

  leftArrow.addEventListener('click', () => slideCarousel('left'));
  rightArrow.addEventListener('click', () => slideCarousel('right'));
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Sheep"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var carousel = $(".customizable-blocks");
  carousel.slick({
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" style="color: #77a0b1;">❮</button>',
    nextArrow: '<button type="button" class="slick-next" style="color: #77a0b1;">❯</button>'
  });

  // Get the modal and the close button
  var modal = document.getElementById("myModal");
  var closeButton = document.getElementsByClassName("close")[0];

  // Create the modal content
var createModalContent = function() {
  var currentExpanded = $("#shopify-section-Donkies .customizable-blocks").clone();
  currentExpanded.find('.slick-prev, .slick-next').remove(); // Remove the carousel controls
  currentExpanded.find('.customizable-block').css({
    'display': 'inline-block',
    'width': '25%',
    'margin': '0 5px 10px' // Add the margin to the block
  }); // Display blocks inline
  currentExpanded.removeClass('slick-initialized slick-slider').removeAttr('dir').css({
    'display': 'flex',
    'flex-wrap': 'wrap', // Wrap the blocks
    'justify-content': 'center', // Center the blocks
    'max-height': 'calc(100vh - 4%)', // Set max-height to 100vh - 4% to account for the vertical margins
    'overflow': 'auto' // Enable scrolling when content exceeds the maximum height
  }); // Remove slick-related attributes and display as flex
  currentExpanded.find('.slick-slide').css({
    'width': 'auto',
    'position': 'static'
  }); // Set the width of the slick-slide to auto and position to static
  currentExpanded.find('.slick-list').css('width', '100%'); // Set the width of the slick-list to 100%
  currentExpanded.find('.slick-track').css('width', 'auto'); // Set the width of the slick-track to auto
  return currentExpanded.html();
};

  // Open the modal and display the content
  $(".expand-button").on("click", function() {
    modal.style.display = "block";
    $(".modal-content .content").html( $(this).closest('.customizable-blocks-wrapper').find('.customizable-blocks1').html());
  });

  // Close the modal when the close button is clicked
  closeButton.onclick = function() {
    modal.style.display = "none";
  };

  // Close the modal when the user clicks outside the modal content
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  // Change the background color of empty headers and text boxes
  $(".customizable-block h2, .customizable-block p").each(function() {
    if ($(this).text().trim() === "") {
      $(this).css("background-color", "#dceceb");
    }
  });

  $(".customizable-block h2").each(function() {
    var headerText = $(this).text();
    var blockUrl = $(this).parent().find("a").attr("href");
    $(this).html('<a href="' + blockUrl + '" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: none;">' + headerText + '</a>');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customizable-repeatable-blocks"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
 var carousel = $(".customizable-blocks");
carousel.slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="slick-prev" style="color: #77a0b1;">❮</button>',
  nextArrow: '<button type="button" class="slick-next" style="color: #77a0b1;">❯</button>'
});

$(".expand-button").on("click", function() {
  var sectionWrapper = $(this).closest(".customizable-blocks-wrapper");
  var sectionCarousel = sectionWrapper.find(".customizable-blocks");

  sectionCarousel.slick("unslick");
  sectionCarousel.children().css("width", "calc(26.66% - 10px)");
  $(this).hide();
  sectionCarousel.css("margin-left", "auto");
  sectionCarousel.css("margin-right", "auto");
  sectionWrapper.find(".customizable-block p").css("display", "none");
  sectionWrapper.find(".block-button").hide();
  $(this).addClass("expanded");
  sectionWrapper.addClass("expanded"); // Add the "expanded" class to the section wrapper
  sectionWrapper.find(".customizable-block h2").addClass("btn btn-secondary expanded-header"); // Apply "btn btn-secondary" class to header when expanded
});
  // Change the background color of empty headers and text boxes
  $(".customizable-block h2, .customizable-block p").each(function() {
    if ($(this).text().trim() === "") {
      $(this).css("background-color", "#dceceb");
    }
  });

  $(".customizable-block h2").each(function() {
    var headerText = $(this).text();
    var blockUrl = $(this).parent().find("a").attr("href");
    $(this).html('<a href="' + blockUrl + '" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: none;">' + headerText + '</a>');
  });
});

  } catch(e) { console.error(e); }
})();
})();
